const checkDependsOn = (parts, flatConfigurationParts) => {
    const result = [];
    parts.forEach((part) => {
        const dependsOns = part.depends_on;

        const enabledDependsOns = dependsOns.filter((dependsOn) => {
            const found = flatConfigurationParts.filter(
                (selectedItem) => selectedItem.uid === dependsOn
            );
            return found.length !== 0;
        });

        if (dependsOns.length !== 0 && enabledDependsOns.length < dependsOns.length) {
            result.push(part.uid);
        }
    });
    return result;
};

export default checkDependsOn;
